import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber } from '../../../../../../../helpers/custom-prop-types';
import ArrowDownIcon from '../../../../../../Icon/Svg/ArrowDownIcon';
import ArrowUpIcon from '../../../../../../Icon/Svg/ArrowUpIcon';
const RfpOneDescriptionPriceAverage = (props) => {
    const { diff } = props;
    const gtZero = diff > 0;
    if (diff === 0) {
        return (_jsx("span", Object.assign({ className: 'rfp-description-number-average' }, { children: "\uFF08\u5E73\u5747\u91D1\u984D\u3067\u3059\uFF09" })));
    }
    return (_jsxs("span", Object.assign({ className: 'rfp-description-number-average' }, { children: ["\uFF08\u5E73\u5747\u3088\u308A", _jsxs("span", Object.assign({ className: `average_text ${gtZero ? 'is-gt-zero' : ''}` }, { children: [`${Math.abs(diff).toLocaleString()}万円`, gtZero ? (_jsx(ArrowUpIcon, { className: 'average_icon' })) : (_jsx(ArrowDownIcon, { className: 'average_icon' }))] })), "\uFF09"] })));
};
RfpOneDescriptionPriceAverage.propTypes = {
    diff: propNumber().isRequired,
};
export default RfpOneDescriptionPriceAverage;
